import { FC, ReactNode } from 'react';
import { ReactComponent as InfoIcon } from '../../../assets/svg/info.svg';
import styles from './InfoBox.module.scss';

interface InfoBoxProps {
  title?: string;
  description?: string;
  icon?: ReactNode;
  customStyle?: React.CSSProperties;
}

const InfoBox: FC<InfoBoxProps> = ({ 
  title, 
  description, 
  icon = <InfoIcon />,
  customStyle
}) => {
  const hasTitle = title && title.trim() !== '';
  const hasDescription = description && description.trim() !== '';
  
  if (!hasTitle && !hasDescription) {
    return null; // Don't render if both are empty
  }

  return (
    <div className={styles.infoBox} style={customStyle}>
      {icon}
      <div className={styles.infoContent}>
        {hasTitle && (
          <div className={styles.infoTitle}>
            {title}
          </div>
        )}
        {hasDescription && (
          <div className={`${styles.infoDescription} ${!hasTitle ? styles.centered : ''}`}>
            {description}
          </div>
        )}
      </div>
    </div>
  );
};

export default InfoBox;
